import React, { useEffect, useState } from 'react';

import { StyleSheet, Text, View } from 'react-native';
import { getColors } from '../../constants/colors';
import { MB_Button } from '@mightybyte/rnw.components.button';
import { textStyles } from '../../constants/textStyles';
import { UniversalScreenNavigationProp } from '../../typesAndInterfaces/componentProps';
import { BarIndicator } from '@mightybyte/rnw.components.activity-indicators';
import { useSignedInContext } from '../../context/SignedInContext';

export enum LOADING_PAGE_GIVE_UP_ACTION_TYPES {
    signOut = 'signOut',
    backToHome = 'backToHome'
}

// TODO: Needs review and design

const LoadingPage = ({ giveUpActionTypes, navigation, hideGiveUpButton }: { giveUpActionTypes?: LOADING_PAGE_GIVE_UP_ACTION_TYPES, navigation?: UniversalScreenNavigationProp, hideGiveUpButton?: boolean }) => {
    const [isLoadingVisibleInternal, setIsLoadingVisibleInternal] = useState(false);
    const [isGiveUpButtonVisible, setIsGiveUpButtonVisible] = useState(false);
    const { signOut } = useSignedInContext();

    useEffect(() => {
        const buttonTimeout = setTimeout(() => { setIsGiveUpButtonVisible(true); }, 5000);
        const viewTimeout = setTimeout(() => { setIsLoadingVisibleInternal(true); }, 500);

        return () => {
            clearTimeout(buttonTimeout);
            clearTimeout(viewTimeout);
        };
    }, []);

    if (!isLoadingVisibleInternal) {
        return <View style={styles.container} />;
    }

    const onGiveUpButtonPressed = () => {
        if (giveUpActionTypes === LOADING_PAGE_GIVE_UP_ACTION_TYPES.signOut) {
            signOut({ skipSignOutRequest: true });
        } else {
            navigation?.reset({
                index: 0,
                routes: [{ name: navigation.getState().routeNames[0] }],
            });
        }
    };

    return (
        <View style={styles.container}>

            <View>
                <BarIndicator color={COLORS.secondaryColor} count={5} style={{ alignSelf: 'center', marginBottom: 32, flex: undefined }} />

                <Text style={[textStyles.largerText, {color: COLORS.primaryColor}]}>Loading...</Text>

                {isGiveUpButtonVisible && !hideGiveUpButton &&
                    <MB_Button
                        title={giveUpActionTypes === LOADING_PAGE_GIVE_UP_ACTION_TYPES.signOut ? 'Sign Out' : 'Back to Home Page'}
                        onPress={onGiveUpButtonPressed}
                        style={{ marginTop: 16 }}
                    />
                }
            </View>
        </View>
    );
};

export { LoadingPage };

const COLORS = getColors();

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.backgroundPrimary,
        alignItems: 'center',
        justifyContent: 'center',
    },
    loginBannerContainer: {
        position: 'absolute',
        top: 0,
        width: '100%',
    },
});
